// #region COMPONENTS COMPOSABLES
import DetailRequest from '../views/detail-request/DetailRequest.vue';
// #endregion

export default [
  {
    path: '/detalle-solicitud',
    name: 'DetailRequest',
    component: DetailRequest,
    meta: {
      title: 'Detalle solicitud',
      staticBreadCrumbs: [
        {
          text: 'Transporte Terrestre',
          link: 'https://www.transportes.gob.es/transporte_terrestre',
        },
        {
          text: 'Viajeros de autobús y tren',
          link: 'https://www.transportes.gob.es/transporte_terrestre#Viajeros_de_autobus_y_tren',
        },
        {
          key: 'main',
          dynamic: true,
          // text: '',
          // link: STTEDRA_URL_AMPLIFY_INFORMATION || 'https://www.transportes.gob.es/transporte_terrestre/verano-joven',
          link: '',
          route: 'Home',
        },
        {
          text: 'Detalle de solicitud',
          link: '',
        },
      ],
    },
  },
];
